import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import React from "react";
import { exclusionNames } from "../../../utils/consts";

const ExclusionNamesSelect = ({
  t,
  checkedName,
  setCheckedName,
}) => {

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedName(data);
  };

  return (
    <>
      <FormControl>
        <InputLabel id="exclusion-simple-select-label">{t("exclusions.table.name")}</InputLabel>
        {/* No need to change on Autocomplete component (few options) */}
        <Select
          labelId="exclusion-simple-select-label"
          id="service-simple-select"
          value={checkedName ?? null}
          onChange={handleChangeSelect}
        >
          {<MenuItem value={null}>{t("exclusions.createForm.all")}</MenuItem>}
          {exclusionNames.map((value, key) => (
            <MenuItem
              key={key}
              value={value}
            >
              {t(`exclusions.names.${value}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default ExclusionNamesSelect;